// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"84623f8d","390":"c4fb8d3f","770":"43b0a6be"}[chunkId] + ".chunk.js";
};